import * as React from 'react'
import './styles.css'

const faq = new Map<string, JSX.Element>()
    .set(
    'Why do you have a FAQ?',
    <p>To express the inner me. The raw me. This FAQ is a passive try at finding like-minded people</p>)

    .set(
    'Biggest gripe in life?',
    <p>Born too late to witness it all begin, born too early to watch it end</p>)

    .set(
    'Are you on any medications?',
    <a target='_blank' href='https://soundcloud.com/neek-8/sets/phouse'>Yes, music</a>)

    .set(
    'One and only one genie wish?',
    <span><kbd>Ctrl</kbd>+<kbd>Z</kbd> in real life</span>)

    .set(
    'Favorite color?',
    <code style={{background: '#0be476', borderRadius: '3px', color: '#0e0e0e'}}>#0be476</code>)

    .set(
    'Next up on wishlist?',
    <span>😘 <a target='_blank' href='http://a.co/2xacFZG'>Mixtrack Pro 3 Controller</a> <br /> (My birthday is on August 7 BTW)</span>)

export default () => (
    <section className='faq-s'>
        <ul>
            {Array.from(faq.entries()).map(([q, a], i) => (
                <li key={i}>
                    <h4>{q}</h4>
                    <div>{a}</div>
                </li>
            ))}
        </ul>
    </section>
)


// WEBPACK FOOTER //
// ./src/components/FAQ/index.tsx